/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

export default baseIsNaN;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseIsNaN.js
// module id = 468
// module chunks = 31 32 33 34 35